<template>
  <div class="acceptance-page">
    <app-view-layout header="Projekty do akceptacji">
      <template
        v-if="dataFetched"
        #content
      >
        <template v-if="projectsList.length">
          <AcceptancePanel
            :key="activeProject.id"
            :projects-count="projectsList.length"
            :project="activeProject"
            @changeProject="changeProject"
          />
          <AwaitingProjects
            :projects="projectsList"
            @changeProject="changeProject"
          />
        </template>
        <AppEmptyList
          v-else
          key="emptyList"
          class="acceptance-page__empty"
          header="Brak projektów do akceptacji."
          text="Nie znaleziono pasujących projektów"
        />
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';
import AcceptancePanel from '@/components/Projects/Acceptance/AcceptancePanel.vue';
import AwaitingProjects from '@/components/Projects/Acceptance/AwaitingProjects.vue';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    AppViewLayout,
    AppEmptyList,
    AcceptancePanel,
    AwaitingProjects,
  },
  data: () => ({
    activeProjectIndex: 0,
    dataFetched: false,
  }),
  computed: {
    ...mapState('quickAcceptance', [
      'projectsList',
    ]),
    activeProject() {
      return this.projectsList[this.activeProjectIndex] || {};
    },
  },
  watch: {
    projectsList() {
      this.activeProjectIndex = 0;
    },
  },
  created() {
    this.fetchProjects()
      .then(() => {
        this.dataFetched = true;
      });
  },

  methods: {
    ...mapActions('quickAcceptance', [
      'fetchProjects',
    ]),
    changeProject({ index, dir }) {
      if (typeof index === 'number') {
        this.activeProjectIndex = index;
      } else if (dir === 'next') {
        if (this.activeProjectIndex === this.projectsList.length - 1) this.activeProjectIndex = 0;
        else this.activeProjectIndex += 1;
      } else if (dir === 'prev') {
        if (this.activeProjectIndex === 0) this.activeProjectIndex = this.projectsList.length - 1;
        else this.activeProjectIndex -= 1;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.acceptance-page__empty {
  min-height: calc(100vh - 220px);
}
</style>
